import { ui } from "../lib/ui";

function initials(name: string): string {
  const result = name.trim().split(/\s+/).slice(0, 2).map((part) => part[0]?.toUpperCase()).join("");
  return result || "?";
}

function identityTone(value: string): number {
  let hash = 0;
  for (const character of value) hash = ((hash << 5) - hash + character.charCodeAt(0)) | 0;
  return Math.abs(hash % 8);
}

export function CameraOffIdentity({ name, avatarUrl, guest = false, large = false }: { name: string; avatarUrl?: string; guest?: boolean; large?: boolean }) {
  const tone = identityTone(name);
  return (
    <div className={`camera-off camera-off--tone-${tone}${large ? " camera-off--large" : ""}`}>
      {avatarUrl ? <img src={avatarUrl} alt="" /> : <span aria-hidden="true">{initials(name)}</span>}
      <span className="sr-only">{ui(`${name}${guest ? ", guest" : ""}, camera off`, `${name}${guest ? ", гость" : ""}, камера выключена`)}</span>
    </div>
  );
}
